export const STANDARD_INPUT_TYPES = [
  'arraysTest',
  'booleansTest',
  'dateTest',
  'datetimeTest',
  'emailsTest',
  'filesTest',
  'imagesTest',
  'videosTest',
  'numbersTest',
  'objectsTest',
  'referenceTest',
  'slugsTest',
  'stringsTest',
  'textsTest',
  'urlsTest',
  'globalDocumentReferenceTest',
]

export const STANDARD_PORTABLE_TEXT_INPUT_TYPES = [
  'pt_allTheBellsAndWhistles',
  'pt_customMarkersTest',
  'pt_customWithDefaults',
  'blocksTest',
  // 'richTextObject',
  'customPlugins',
  'simpleBlock',
  'manyEditors',
  'documentWithHoistedPt',
  'pt_customBlockEditors',
  'initialFullScreenPTE',
]

export const PLUGIN_INPUT_TYPES = [
  'codeTest',
  'geopointTest',
  //'orderableCategory',
  //'orderableTag',
]

export const DEBUG_INPUT_TYPES = [
  'actionsTest',
  'longValidationTest',
  'allFieldsGroupHidden',
  'allNativeInputComponents',
  'manyViews',
  'decorations',
  'collapsibleColumnsBug',
  'collapsibleObjects',
  'commentsDebug',
  'domAttrsAsFieldNames',
  'conditionalFieldsTest',
  'conditionalFieldsWithPathTest',
  'customInputsTest',
  'customInputsWithPatches',
  'dateValidation',
  'dateTimeValidation',
  'deprecatedFields',
  'deprecatedDocument',
  'documentActionsTest',
  'documentWithHoistedPt',
  'empty',
  'fieldActionsTest',
  'fieldComponentsTest',
  'fieldsetsTest',
  'fieldValidationInferReproDoc',
  'focusTest',
  'hiddenCurrentUserTest',
  'hiddenFieldValidationTest',
  'patchOnMountDebug',
  'formInputDebug',
  'initialValuesTest',
  'inspectorsTest',
  'invalidPreviews',
  'languageFilterDebug',
  'lazyComponents',
  'manyFieldsTest',
  'noTitleField',
  'navbarSettings',
  'objectsDebug',
  'poppers',
  'presence',
  'previewImageUrlTest',
  'previewMediaTest',
  'previewSelectBugRepro',
  'ptReference',
  'radio',
  'readOnlyTest',
  'recursiveArraysTest',
  'recursiveDocument',
  'recursiveObjectTest',
  'recursivePopoverTest',
  'removeRestoreActionTest',
  'reservedKeywordsTest',
  'scrollBug',
  'select',
  'simpleArrayOfObjects',
  'arrayCapabilities',
  'simpleReferences',
  'thesis',
  'typeWithNoToplevelStrings',
  'uploadsTest',
  'validationTest',
  'virtualizationDebug',
  'virtualizationInObject',
  'annotationCustomTypeTest',
  'arrayModalWidthReproTest',
  'nestedArrayInsertMenuRepro',
  'arrayOfStringsGridCustomInputTest',
  'withObjectFieldsOrder',
]

export const CI_INPUT_TYPES = ['conditionalFieldset', 'validationCI', 'textsTest', 'commentsCI']
export const DEBUG_FIELD_GROUP_TYPES = [
  'fieldGroups',
  'fieldGroupsDefault',
  'fieldGroupsMany',
  'fieldGroupsWithI18n',
  'fieldGroupsWithValidation',
  'fieldGroupsWithFieldsets',
  'fieldGroupsWithFieldsetsAndValidation',
  'fieldGroupsWithFieldsetsHidden',
]

export const EXTERNAL_PLUGIN_INPUT_TYPES = [
  'internationalizedArrayTest',
  'documentI18nTest',
  'translation.metadata',
]
